"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleRuntimeError = exports.isTruthy = exports.isDefined = exports.introduceBinding = exports.syntheticIdentifierPrefix = exports.setVariable = exports.getVariable = exports.extendCurrentEnvironment = exports.pushEnvironment = exports.popEnvironment = exports.replaceEnvironment = exports.currentEnvironment = void 0;
const errors = require("../errors/errors");
// ======================= Environment ===========================
const currentEnvironment = (context) => context.runtime.environments[0];
exports.currentEnvironment = currentEnvironment;
const replaceEnvironment = (context, environment) => (context.runtime.environments[0] = environment);
exports.replaceEnvironment = replaceEnvironment;
const popEnvironment = (context) => context.runtime.environments.shift();
exports.popEnvironment = popEnvironment;
const pushEnvironment = (context, environment) => context.runtime.environments.unshift(environment);
exports.pushEnvironment = pushEnvironment;
const extendCurrentEnvironment = (context, name, head = {}) => {
    return {
        name,
        tail: exports.currentEnvironment(context),
        head
    };
};
exports.extendCurrentEnvironment = extendCurrentEnvironment;
const getVariable = (context, name) => {
    let environment = context.runtime.environments[0];
    while (environment) {
        if (environment.head.hasOwnProperty(name)) {
            return environment.head[name];
        }
        else {
            environment = environment.tail;
        }
    }
    return null;
};
exports.getVariable = getVariable;
const setVariable = (context, name, value) => {
    let environment = context.runtime.environments[0];
    while (environment) {
        if (environment.head.hasOwnProperty(name)) {
            environment.head[name] = value;
            return;
        }
        else {
            environment = environment.tail;
        }
    }
    return exports.handleRuntimeError(context, new errors.UndefinedVariable(name, context.runtime.nodes[0]));
};
exports.setVariable = setVariable;
exports.syntheticIdentifierPrefix = '$:';
const isAllowedAsUserIdentifier = (name) => {
    return !name.startsWith(exports.syntheticIdentifierPrefix);
};
const introduceBinding = (context, frame, isUserIdentifier, name, value) => {
    if (isUserIdentifier && !isAllowedAsUserIdentifier(name)) {
        return exports.handleRuntimeError(context, new errors.DisallowedIdentifier(name, context.runtime.nodes[0]));
    }
    frame[name] = value;
};
exports.introduceBinding = introduceBinding;
const isDefined = (context, name) => {
    return !!exports.getVariable(context, name);
};
exports.isDefined = isDefined;
// ======================= Evaluation ===========================
const isTruthy = (value) => value.type !== 'boolean' || value.value;
exports.isTruthy = isTruthy;
const handleRuntimeError = (context, error) => {
    context.errors.push(error);
    context.runtime.environments = context.runtime.environments.slice(-context.numberOfOuterEnvironments);
    throw error;
};
exports.handleRuntimeError = handleRuntimeError;
//# sourceMappingURL=util.js.map